import { render } from "./KindUploadFolderGroupComponent.vue?vue&type=template&id=2c9be492"
import script from "./KindUploadFolderGroupComponent.vue?vue&type=script&lang=js"
export * from "./KindUploadFolderGroupComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__